import React, {useEffect} from 'react';

import {cn} from "../../../utils/cn.ts";

import {useClickOutside} from "../../../hooks/useClickOutside.tsx";
import {Button} from "../../General/Button/Button.tsx";
import {closeIcon, filtersIcon} from "../../../assets/icons/icons.ts";

import styles from './DrawerMobile.module.css'
import {useBodyScrollLock} from "../../../hooks/useBodyScrollLock.tsx";

interface Props {
    title: string,
    closeFilter: boolean,
    setCloseFilter: (closeFilter: boolean) => void,
}

export const DrawerMobile: React.FC<Props & React.HTMLAttributes<HTMLDivElement>> = ({children, title, setCloseFilter, closeFilter = false}) => {
    const {containerRef, isOpen, open, close} = useClickOutside()
    useBodyScrollLock(isOpen)

    const handleOpen = () => {
        setCloseFilter(false);
        open();
    }

    useEffect(() => {
        if(closeFilter) close();
    }, [closeFilter]);

    return (
        <div ref={containerRef} className={styles.mobile}>
            <Button className={styles.btn} type='regular' onClick={handleOpen}>
                Фильтр
                <img className={styles.btnIcon} width={22} height={24} src={filtersIcon} alt='Фильтры'/>
            </Button>
            <div className={cn(styles.drawer, isOpen && styles.drawerOpen)}>
                <div className={styles.header}>
                    <div className={styles.headerTitle}>
                        {title}
                    </div>
                    <img className={styles.closeBtn} src={closeIcon} alt='Закрыть модал' onClick={close}/>
                </div>
                <div className={styles.content}>
                    {children}
                </div>
            </div>
        </div>
    )
};